document.addEventListener("DOMContentLoaded", () => {

    const menu = document.getElementById("mobileMenu");
    let historyStack = [];

    menu.querySelectorAll("[data-target]").forEach(item => {
        item.addEventListener("click", () => {

            const target = item.getAttribute("data-target");
            const current = menu.querySelector(".menu-panel.active");
            const next = menu.querySelector(`[data-parent="${target}"]`);

            if (!next) return;

            historyStack.push(current);

            current.classList.remove("active");
            current.classList.add("prev");

            next.classList.add("active");
        });
    });

    menu.querySelectorAll(".back").forEach(btn => {
        btn.addEventListener("click", () => {

            const current = menu.querySelector(".menu-panel.active");
            const prev = historyStack.pop();

            if (!prev) return;

            current.classList.remove("active");

            prev.classList.remove("prev");
            prev.classList.add("active");
        });
    });

});

document.querySelector(".all-trigger").addEventListener("click", (e) => {
    e.preventDefault();
    document.querySelector(".mobile-menu").classList.add("open");
});

document.querySelector(".back.two").addEventListener("click", () => {
    document.querySelector(".mobile-menu").classList.remove("open");
});

document.addEventListener('DOMContentLoaded', function () {

    const messageEl = document.getElementById('newsletter-message');
    const form = document.getElementById('newsletter-form');

    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has('customer_posted')) {
        if (messageEl) {
            messageEl.innerHTML = '<p style="color:#1ab5ed;">Thanks for subscribing!</p>';
        }

        if (form) {
            setTimeout(() => {
                form.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }, 200);
        }
    }

});

document.addEventListener("DOMContentLoaded", function () {

    if (!document.body.classList.contains('template-page-location')) return;

    const location = window.locationName;

    function replaceText(node) {
        if (node.nodeType === Node.TEXT_NODE) {
            node.nodeValue = node.nodeValue.replace(/\bBarnsley\b/g, location);
        } else if (
            node.nodeType === Node.ELEMENT_NODE &&
            !['SCRIPT', 'STYLE', 'NOSCRIPT'].includes(node.tagName)
        ) {
            node.childNodes.forEach(replaceText);
        }
    }

    replaceText(document.body);

});

document.addEventListener('DOMContentLoaded', function () {
    const inputs = document.querySelectorAll('.price-filter');

    inputs.forEach(input => {
        input.addEventListener('change', () => {

            inputs.forEach(i => {
                if (i !== input) i.checked = false;
            });

            if (!input.checked) {
                window.location = window.location.pathname;
                return;
            }

            const min = input.dataset.min;
            const max = input.dataset.max;

            window.location = `${window.location.pathname}?filter.v.price.gte=${min}&filter.v.price.lte=${max}`;
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".spec-accordion").forEach(button => {
        button.addEventListener("click", function () {
            const content = document.getElementById(this.dataset.target);

            this.classList.toggle("active");

            if (content.style.maxHeight) {
                content.style.maxHeight = null;
            } else {
                content.style.maxHeight = content.scrollHeight + "px";
            }
        });
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const sidebarGroups = document.querySelectorAll(".filter-group");
    const urlParams = new URLSearchParams(window.location.search);

    sidebarGroups.forEach(function (group) {
        const btn = group.querySelector(".filter-heading");
        const content = group.querySelector(".filter-content");

        if (!btn || !content) return;

        const headingText = btn.textContent.trim().toLowerCase();

        function openGroup() {
            btn.classList.add("active");
            content.classList.add("open");
            content.style.display = "block";
            content.style.maxHeight = content.scrollHeight + "px";
        }

        function closeGroup() {
            btn.classList.remove("active");
            content.classList.remove("open");
            content.style.maxHeight = null;
            content.style.display = "none";
        }

        btn.addEventListener("click", function () {
            if (content.classList.contains("open")) {
                closeGroup();
            } else {
                openGroup();
            }
        });

        const hasCheckedInput = group.querySelector('input:checked');
        const hasPriceInUrl =
            urlParams.has('filter.v.price.gte') || urlParams.has('filter.v.price.lte');

        if (hasCheckedInput || (headingText === 'price range' && hasPriceInUrl)) {
            openGroup();
        }
    });
});

document.querySelectorAll('.vat-option').forEach(button => {
    button.addEventListener('click', function () {

        document.querySelectorAll('.vat-option').forEach(btn => btn.classList.remove('active'));

        this.classList.add('active');

        document.getElementById('vatStatusInput').value = this.dataset.value;

        const wrapper = document.querySelector('.vat-select-wrapper');
        if (this.dataset.value === 'exempt') {
            wrapper.style.display = 'block';
        } else {
            wrapper.style.display = 'none';
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {

    const wrapper = document.querySelector(".cta-video-wrapper");
    const modal = document.querySelector(".cta-video-modal");
    const iframe = document.querySelector(".cta-video-modal iframe");
    const closeBtn = document.querySelector(".cta-modal-close");

    if (wrapper) {
        wrapper.addEventListener("click", function () {
            const url = wrapper.getAttribute("data-video");
            iframe.src = url.replace("watch?v=", "embed/") + "?autoplay=1";
            modal.style.display = "flex";
        });
    }

    if (closeBtn) {
        closeBtn.addEventListener("click", function () {
            iframe.src = "";
            modal.style.display = "none";
        });
    }

});

const form = document.getElementById('product-search');
const searchInput = document.getElementById('search-input');
const resultsBox = document.getElementById('predictive-results');

let controller = null;

searchInput.addEventListener('input', async function () {
    const q = this.value.trim();

    if (!q) {
        resultsBox.innerHTML = '';
        return;
    }

    if (controller) controller.abort();
    controller = new AbortController();

    try {
        const res = await fetch(
            `${window.Shopify.routes.root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,page,article`, {
                signal: controller.signal
            }
        );

        const data = await res.json();
        renderResults(data.resources.results);
    } catch (e) {
        if (e.name !== 'AbortError') {
            resultsBox.innerHTML = `<div class="no-results">Something went wrong</div>`;
        }
    }
});

form.addEventListener('submit', function (e) {
    e.preventDefault();

    const q = searchInput.value.trim();
    if (!q) return;

    window.location.href = `${window.Shopify.routes.root}search?q=${encodeURIComponent(q)}`;
});

function renderResults(results) {
    const products = results.products || [];
    const pages = results.pages || [];
    const articles = results.articles || [];

    if (!products.length && !pages.length && !articles.length) {
        resultsBox.innerHTML = `<div class="no-results">No results found</div>`;
        return;
    }

    resultsBox.innerHTML = `
    ${products.length ? `
      <div class="result-group">
        <div class="result-heading">Products</div>
        ${products.map(product => `
          <a href="${product.url}" class="suggestion">
            ${product.image ? `<img src="${product.image}" alt="${product.title}">` : ''}
            <div class="title">${product.title}</div>
          </a>
        `).join('')}
      </div>
    ` : ''}

    ${pages.length ? `
      <div class="result-group">
        <div class="result-heading">Pages</div>
        ${pages.map(page => `
          <a href="${page.url}" class="suggestion">
            <div class="title">${page.title}</div>
          </a>
        `).join('')}
      </div>
    ` : ''}

    ${articles.length ? `
      <div class="result-group">
        <div class="result-heading">Blog posts</div>
        ${articles.map(article => `
          <a href="${article.url}" class="suggestion">
            <div class="title">${article.title}</div>
          </a>
        `).join('')}
      </div>
    ` : ''}
  `;
}

$(window).on('scroll', function () {
    const topbarHeight = $('.topbar').outerHeight();
    if ($(this).scrollTop() > topbarHeight) {
        $('#header').addClass('sticky');
        $('.specialist-shop-wrapper').addClass('lower');
        $('body').addClass('header-sticky');
    } else {
        $('#header').removeClass('sticky');
        $('.specialist-shop-wrapper').removeClass('lower');
        $('body').removeClass('header-sticky');
    }
});
$(document).ready(function () {

  new SlimSelect({
        select: '#vatIllnessSelect'
      });

 (function () {

  if (document.body.classList.contains('template-page-location')) {
    document.querySelectorAll('.dynamic-phone').forEach(el => {
      el.style.visibility = 'visible';
    });
    return;
  }

  function revealAll() {
    document.querySelectorAll('.dynamic-phone').forEach(el => {
      el.style.visibility = 'visible';
    });
  }

  fetch('https://docs.google.com/spreadsheets/d/1qOUn2rFSLLy5JsRtlWD6tz1XZ6qB5XM_FhMrxsu9w0s/export?format=csv')
    .then(res => res.text())
    .then(csv => {

      const rows = csv.split('\n').slice(1);
      const numbers = {};

      rows.forEach(row => {
        const cols = row.split(',');
        if (cols.length >= 2) {
          const key = cols[0].trim().toLowerCase();
          const phone = cols[1].trim();
          if (key && phone) numbers[key] = phone;
        }
      });

      const params = new URLSearchParams(window.location.search);

      let key =
        params.get('utm_campaign') ||
        params.get('campaignid') ||
        params.get('utm_source') ||
        localStorage.getItem('phone_key');

      if (key) {
        key = key.toLowerCase();
        localStorage.setItem('phone_key', key);
      }

      const phone = numbers[key] || numbers['default'];
      if (!phone) {
        revealAll();
        return;
      }

    const raw = phone.trim();

    let clean = raw.replace(/\D/g, '');

    if (clean.startsWith('44')) {
    clean = '0' + clean.slice(2);
    }

    if (!clean.startsWith('0')) {
    clean = '0' + clean;
    }

    let display = raw;


    if (!raw.trim().startsWith('0')) {
    display = '0' + raw.trim();
    }

    const tel = clean;

        document.querySelectorAll('.dynamic-phone').forEach(el => {
            el.textContent = display;

            const link = el.closest('a');
            if (link) link.href = 'tel:' + tel;

            el.style.visibility = 'visible';
        });

        document.querySelectorAll('a[href*="tel:"]').forEach(link => {
            if (link.hasAttribute('data-no-swap')) return;

            link.href = 'tel:' + tel;

            const text = link.textContent.trim();
            if (text.replace(/\D/g, '').length >= 10) {
            link.textContent = display;
            }
        });

        })
        .catch(() => {
        revealAll();
        });

    })();

    $('.specialist-item.has-submenu').on('click', function (e) {

    if ($(window).width() < 600) {
        e.preventDefault();

        var $currentSubmenu = $(this).next('.mobile-sub-menu');

        $('.mobile-sub-menu')
            .not($currentSubmenu)
            .slideUp(250)
            .removeClass('open');

        $currentSubmenu
            .stop(true, true)
            .slideToggle(250)
            .toggleClass('open');

        $(this).toggleClass('active-parent');
    }

});

    var $backToTop = $('#backToTop');
    var triggerPoint = $(window).height() * 0.5;

    function toggleBackToTop() {
        if ($(window).scrollTop() > triggerPoint) {
            $backToTop.addClass('show');
        } else {
            $backToTop.removeClass('show');
        }
    }

    $(window).on('scroll', function () {
        toggleBackToTop();
    });

    $(window).on('resize', function () {
        triggerPoint = $(window).height() * 0.5;
        toggleBackToTop();
    });

    $backToTop.on('click', function () {
        $('html, body').animate({
            scrollTop: 0
        }, 400);
    });

    toggleBackToTop();

    $('.filter-button').on('click', function () {

        var modalID = $(this).data('modal');
        var $target = $('.modal[data-modal="' + modalID + '"]');

        $('.modal').not($target).removeClass('active');
        $target.toggleClass('active');

    });

    function moveSocial() {

        if ($(window).width() < 600) {

            $('.social').insertBefore('footer .desktop-only');

        } else {

            $('.social').appendTo('footer .container .col:last');

        }

    }

    $(document).ready(function () {
        moveSocial();
    });

    $(window).resize(function () {
        moveSocial();
    });

    $(document).on('change', '#form_input_2', function () {

        var value = $(this).val();

        var form = $(this).closest('form');

        form.removeClass('product-scooters product-powerchairs product-recliners product-stairlifts product-other');

        if (value === "Mobility Scooters") {
            form.addClass('product-scooters');
        }

        if (value === "Powerchairs") {
            form.addClass('product-powerchairs');
        }

        if (value === "Recliners") {
            form.addClass('product-recliners');
        }

        if (value === "Stairlifts") {
            form.addClass('product-stairlifts');
        }

        if (value === "Other Product") {
            form.addClass('product-other');
        }

    });

    $('.location-gallery').owlCarousel({

        loop: true,
        margin: 20,
        nav: false,
        dots: false,
        stagePadding: 80,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        autoplaySpeed: 800,
        responsive: {
            0: {
                items: 1,
                margin: 20
            },
            768: {
                items: 2,
                margin: 20
            },
            1100: {
                items: 4,
                margin: 30
            }
        }

    });

    function updateParam(param, value) {
        const url = new URL(window.location.href);
        const params = url.searchParams;

        if (value === null || value === "") {
            params.delete(param);
        } else {
            params.set(param, value);
        }

        params.delete("page");

        window.location = url.pathname + "?" + params.toString();
    }

    $('.price-filter').on('change', function () {

        $('.price-filter').not(this).prop('checked', false);

        const url = new URL(window.location.href);
        const params = url.searchParams;

        if (!$(this).prop('checked')) {
            params.delete("filter.v.price.gte");
            params.delete("filter.v.price.lte");
            params.delete("page");
            window.location = url.pathname + "?" + params.toString();
            return;
        }

        const min = $(this).data('min').toString();
        const max = $(this).data('max').toString();

        params.set("filter.v.price.gte", min);
        params.set("filter.v.price.lte", max);

        params.delete("page");

        window.location = url.pathname + "?" + params.toString();
    });

    const urlParams = new URLSearchParams(window.location.search);

    let min = urlParams.get("filter.v.price.gte");
    const max = urlParams.get("filter.v.price.lte");

    if (!min && max) {
        min = "0";
    }

    $('.price-filter').each(function () {
        const boxMin = $(this).data('min').toString();
        const boxMax = $(this).data('max').toString();

        if (min && max && boxMin === min && boxMax === max) {
            $(this).prop('checked', true);
        } else {
            $(this).prop('checked', false);
        }
    });

    $('.availability-filter').on('change', function () {

        $('.availability-filter').not(this).prop('checked', false);

        const url = new URL(window.location.href);
        const params = url.searchParams;

        params.delete("filter.v.availability");
        params.delete("filter.v.availability[]");

        if (!$(this).prop('checked')) {
            window.location = url.pathname + "?" + params.toString();
            return;
        }

        const val = $(this).data('value').toString();

        params.set("filter.v.availability", val);

        window.location = url.pathname + "?" + params.toString();
    });

    let availability = null;

    if (urlParams.has("filter.v.availability")) {
        availability = urlParams.get("filter.v.availability");
    } else if (urlParams.has("filter.v.availability[]")) {
        availability = urlParams.get("filter.v.availability[]");
    }

    $('.availability-filter').each(function () {
        const boxVal = $(this).data('value').toString();

        if (availability === boxVal) {
            $(this).prop('checked', true);
        } else {
            $(this).prop('checked', false);
        }
    });

    const $wrapper = $('.specialist-shop-wrapper');
    const $menu1 = $('.header__menu ul li:last-child');

    let isOpen = false;

    $(document).on('mousemove', function (e) {
        const $target = $(e.target);

        const insideMenu = $target.closest($menu1).length > 0;
        const insideWrapper = $target.closest($wrapper).length > 0;

        if ((insideMenu || insideWrapper) && !isOpen) {
            $wrapper.addClass('active');
            isOpen = true;
        }

        if (!insideMenu && !insideWrapper && isOpen) {
            $wrapper.removeClass('active');
            isOpen = false;
        }
    });

    var $mainCarousel = $('.product-images.owl-carousel');
    var $thumbCarousel = $('.product-thumbs');

    if ($mainCarousel.length) {

        $mainCarousel.owlCarousel({
            items: 1,
            loop: false,
            margin: 0,
            nav: true,
            dots: false,
            autoHeight: false,
            mouseDrag: true,
            touchDrag: true,
            navText: [
            '<span class="owl-prev-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7.33 24l-2.83-2.829 9.339-9.175-9.339-9.167 2.83-2.829 12.17 11.996z"/></svg></span>',
            '<span class="owl-next-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"/></svg></span>'
        ]
        });

        $('.product-thumb').on('click', function () {
            var index = parseInt($(this).data('index'), 10);

            $mainCarousel.trigger('to.owl.carousel', [index, 300]);

            $('.product-thumb').removeClass('is-active');
            $(this).addClass('is-active');

            if ($thumbCarousel.length) {
                $thumbCarousel.trigger('to.owl.carousel', [index, 200]);
            }
        });

        $mainCarousel.on('changed.owl.carousel', function (event) {
            var index = event.item.index;

            var $thumbs = $('.product-thumb');
            var $activeThumb = $thumbs.eq(index);

            $thumbs.removeClass('is-active');
            $activeThumb.addClass('is-active');

            if ($thumbCarousel.length) {
                $thumbCarousel.trigger('to.owl.carousel', [index, 200]);
            }
        });
    }

    if ($thumbCarousel.length) {
        $thumbCarousel.owlCarousel({
            margin: 10,
            nav: false,
            dots: false,
            responsive: {
                0: {
                    items: 4,
                    margin: 5
                },
                380: {
                    items: 5,
                    margin: 5
                },
                600: {
                    items: 2
                },
                768: {
                    items: 3
                },
                1200: {
                    items: 4
                }
            }
        });
    }

    $('.more-toggle').on('click', function (e) {
        e.preventDefault();

        $('html, body').animate({
            scrollTop: $('.product-features-section').offset().top - 150
        }, 600);
    });

    $('.more-toggle-2').on('click', function (e) {
        e.preventDefault();

        $('html, body').animate({
            scrollTop: $('.spec-section').offset().top - 80
        }, 600);
    });

    var $hamburger = $(".hamburger");
    var $body = $("body");
    var $menu = $(".specialist-shop-wrapper");

    $hamburger.on("click", function (e) {
        e.preventDefault();

        if ($hamburger.hasClass("is-active")) {
            $hamburger.removeClass("is-active");
            $menu.removeClass("active");
            $body.removeClass("stuck");
            $('.mobile-sub-menu').slideUp(250).removeClass('open');
        } else {
            $hamburger.addClass("is-active");
            $menu.addClass("active");
            $body.addClass("stuck");
        }
    });

    $('.ln-card .inner').matchHeight();
    $('ul.tags').matchHeight();
    $('.collection-product__content h3').matchHeight();
    $('.collection-product__content p').matchHeight();

    const owl = $('.ssc-carousel');
    const progressWrap = $('.ssc-progress');
    const progressBar = $('.ssc-progress-bar');

    const itemCount = owl.children().length;
    const enableCarousel = itemCount > 1;

    owl.on('initialized.owl.carousel changed.owl.carousel', function (event) {
        const total = event.item.count;

        if (total <= 1) {
            progressWrap.hide();
            return;
        } else {
            progressWrap.show();
        }

        let current = event.item.index - event.relatedTarget._clones.length / 2;

        if (current < 0) current = total + current;
        if (current >= total) current = current - total;

        const progress = ((current + 1) / total) * 100;
        progressBar.css('width', progress + '%');
    });

    owl.owlCarousel({
        items: 1,
        loop: enableCarousel,
        margin: 20,

        nav: enableCarousel,
        dots: false,
        autoHeight: true,

        touchDrag: enableCarousel,
        mouseDrag: enableCarousel,
        pullDrag: enableCarousel,

        autoplay: enableCarousel,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,

        navText: [
        '<span class="owl-prev-icon"><svg viewBox="0 0 24 24"><path d="m14.523 18.787s4.501-4.505 6.255-6.26c.146-.146.219-.338.219-.53s-.073-.383-.219-.53c-1.753-1.754-6.255-6.258-6.255-6.258-.144-.145-.334-.217-.524-.217-.193 0-.385.074-.532.221-.293.292-.295.766-.004 1.056l4.978 4.978h-14.692c-.414 0-.75.336-.75.75s.336.75.75.75h14.692l-4.979 4.979c-.289.289-.286.762.006 1.054.148.148.341.222.533.222.19 0 .378-.072.522-.215z"/></svg></span>',
        '<span class="owl-next-icon"><svg viewBox="0 0 24 24"><path d="m14.523 18.787s4.501-4.505 6.255-6.26c.146-.146.219-.338.219-.53s-.073-.383-.219-.53c-1.753-1.754-6.255-6.258-6.255-6.258-.144-.145-.334-.217-.524-.217-.193 0-.385.074-.532.221-.293.292-.295.766-.004 1.056l4.978 4.978h-14.692c-.414 0-.75.336-.75.75s.336.75.75.75h14.692l-4.979 4.979c-.289.289-.286.762.006 1.054.148.148.341.222.533.222.19 0 .378-.072.522-.215z"/></svg></span>'
    ]
    });

    let relatedOwl;

    function handleRelatedCarousel() {
        const $carousel = $('.related-carousel');

        if (window.innerWidth <= 600) {

            if (!$carousel.hasClass('owl-loaded')) {

                relatedOwl = $carousel.owlCarousel({
                    items: 1,
                    loop: true,
                    margin: 0,
                    nav: true,
                    dots: false,
                    autoHeight: true,
                    navText: [
        '<span class="owl-prev-icon"><svg viewBox="0 0 24 24"><path d="m14.523 18.787s4.501-4.505 6.255-6.26c.146-.146.219-.338.219-.53s-.073-.383-.219-.53c-1.753-1.754-6.255-6.258-6.255-6.258-.144-.145-.334-.217-.524-.217-.193 0-.385.074-.532.221-.293.292-.295.766-.004 1.056l4.978 4.978h-14.692c-.414 0-.75.336-.75.75s.336.75.75.75h14.692l-4.979 4.979c-.289.289-.286.762.006 1.054.148.148.341.222.533.222.19 0 .378-.072.522-.215z"/></svg></span>',
        '<span class="owl-next-icon"><svg viewBox="0 0 24 24"><path d="m14.523 18.787s4.501-4.505 6.255-6.26c.146-.146.219-.338.219-.53s-.073-.383-.219-.53c-1.753-1.754-6.255-6.258-6.255-6.258-.144-.145-.334-.217-.524-.217-.193 0-.385.074-.532.221-.293.292-.295.766-.004 1.056l4.978 4.978h-14.692c-.414 0-.75.336-.75.75s.336.75.75.75h14.692l-4.979 4.979c-.289.289-.286.762.006 1.054.148.148.341.222.533.222.19 0 .378-.072.522-.215z"/></svg></span>'
        ]
                });

                $carousel.on('changed.owl.carousel', function (event) {
                    const total = event.item.count;
                    const index = event.item.index - event.relatedTarget._clones.length / 2;

                    let current = index;
                    if (current < 0) current = total + current;
                    if (current >= total) current = current - total;

                    const progress = ((current + 1) / total) * 100;
                    $('.ssc-progress-bar').css('width', progress + '%');
                });

            }

        } else {
            if ($carousel.hasClass('owl-loaded')) {
                $carousel.trigger('destroy.owl.carousel');
                $carousel.removeClass('owl-loaded');
                $carousel.find('.owl-stage-outer').children().unwrap();
            }
        }
    }

    $(document).ready(function () {
        handleRelatedCarousel();
    });

    $(window).on('resize', function () {
        handleRelatedCarousel();
    });

    $('#searchbtn').on('click', function (e) {
        e.preventDefault();

        const isActive = $(this).hasClass('active');

        if (isActive) {
            $(this).removeClass('active').html(`
                <path d="M23.822 20.88l-6.353-6.354c.93-1.465 1.467-3.2 1.467-5.059.001-5.219-4.247-9.467-9.468-9.467s-9.468 4.248-9.468 9.468c0 5.221 4.247 9.469 9.468 9.469 1.768 0 3.421-.487 4.839-1.333l6.396 6.396 3.119-3.12zm-20.294-11.412c0-3.273 2.665-5.938 5.939-5.938 3.275 0 5.94 2.664 5.94 5.938 0 3.275-2.665 5.939-5.94 5.939-3.274 0-5.939-2.664-5.939-5.939z"/>
            `);
            $('#header').removeClass('hassearch');
        } else {
            $(this).addClass('active').html(`
                <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm4.151 17.943l-4.143-4.102-4.117 4.159-1.833-1.833 4.104-4.157-4.162-4.119 1.833-1.833 4.155 4.102 4.106-4.16 1.849 1.849-4.1 4.141 4.157 4.104-1.849 1.849z"/>
            `);
            $('#header').addClass('hassearch');
        }

        $('#header form#product-search').toggleClass('active');
    });

    $('.bs-carousel').owlCarousel({
        items: 3,
        loop: true,
        margin: 25,
        nav: true,
        dots: false,
        responsive: {
            0: {
                items: 1
            },
            768: {
                items: 3
            },
            960: {
                items: 3
            },
            1380: {
                margin: 50
            }
        },
        navText: [
      '<span class="owl-prev-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"/></svg></span>',
      '<span class="owl-next-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7.33 24l-2.83-2.829 9.339-9.175-9.339-9.167 2.83-2.829 12.17 11.996z"/></svg></span>'
    ]
    });

    $('.bs-tab').on('click', function () {

        $('.bs-tab').removeClass('active');
        $(this).addClass('active');

        let tab = $(this).data('tab');

        $('.bs-carousel-wrap').hide();

        let activeWrap = $('#' + tab).show();

        activeWrap.find('.bs-carousel').trigger('refresh.owl.carousel');
    });

    $('.trust-carousel').owlCarousel({
        loop: true,
        margin: 0,
        nav: false,
        dots: false,
        center: true,
        responsive: {
            0: {
                items: 1
            },
            768: {
                items: 2
            },
            960: {
                items: 3
            }
        },
        navText: [
      '<span class="owl-prev-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7.33 24l-2.83-2.829 9.339-9.175-9.339-9.167 2.83-2.829 12.17 11.996z"/></svg></span>',
      '<span class="owl-next-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"/></svg></span>'
    ]
    });

    $('.popular-cats .owl-carousel').owlCarousel({
        loop: true,
        margin: 40,
        nav: true,
        dots: false,
        responsive: {
            0: {
                items: 1,
                margin: 20
            },
            520: {
                items: 1.4,
                margin: 20
            },
            820: {
                items: 2,
                margin: 20
            },
            920: {
                items: 3,
                margin: 20
            },
            1366: {
                items: 3
            }
        },
        navText: [
      '<span class="owl-prev-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"/></svg></span>',
      '<span class="owl-next-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7.33 24l-2.83-2.829 9.339-9.175-9.339-9.167 2.83-2.829 12.17 11.996z"/></svg></span>'
    ]
    });

    if ($('body').hasClass('template-page-rental')) {
        $('.popular-products .owl-carousel').owlCarousel({
            loop: true,
            margin: 50,
            nav: true,
            dots: false,
            responsive: {
                0: {
                    items: 2
                },
                768: {
                    items: 3
                },
                980: {
                    items: 4
                },
                1381: {
                    items: 4
                }
            },
            navText: [
      '<span class="owl-prev-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"/></svg></span>',
      '<span class="owl-next-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7.33 24l-2.83-2.829 9.339-9.175-9.339-9.167 2.83-2.829 12.17 11.996z"/></svg></span>'
    ]
        });
    } else {
        $('.popular-products .owl-carousel').owlCarousel({
            loop: true,
            margin: 25,
            nav: true,
            dots: false,
            responsive: {
                0: {
                    items: 2
                },
                768: {
                    items: 3
                },
                980: {
                    items: 5
                },
                1381: {
                    items: 6
                }
            },
            navText: [
      '<span class="owl-prev-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"/></svg></span>',
      '<span class="owl-next-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7.33 24l-2.83-2.829 9.339-9.175-9.339-9.167 2.83-2.829 12.17 11.996z"/></svg></span>'
    ]
        });
    }

    $('.logo-carousel').owlCarousel({
        loop: true,
        center: false,
        margin: 40,
        autoplay: 1000,
        autoplayHoverPause: true,
        dots: false,
        nav: false,

        responsive: {
            0: {
                items: 2
            },
            600: {
                items: 4
            },
            1000: {
                items: 8
            }
        }
    });

    $('.popular-locations .owl-carousel').owlCarousel({
        loop: true,
        margin: 40,
        nav: true,
        dots: false,
        mouseDrag: false,
        touchDrag: true,
        responsive: {
            0: {
                items: 1
            },
            768: {
                items: 3,
                margin: 20,
            },
            1180: {
                items: 4,
                margin: 40,
            }
        },
        navText: [
      '<span class="owl-prev-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"/></svg></span>',
      '<span class="owl-next-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7.33 24l-2.83-2.829 9.339-9.175-9.339-9.167 2.83-2.829 12.17 11.996z"/></svg></span>'
    ]
    });

    $('.popular-team .owl-carousel').owlCarousel({
        loop: true,
        margin: 40,
        nav: true,
        dots: false,
        responsive: {
            0: {
                items: 2
            },
            768: {
                items: 4
            }
        },
        navText: [
      '<span class="owl-prev-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z"/></svg></span>',
      '<span class="owl-next-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M7.33 24l-2.83-2.829 9.339-9.175-9.339-9.167 2.83-2.829 12.17 11.996z"/></svg></span>'
    ]
    });

});